export default "__VITE_ASSET__NM3BJHL7__"